<template>
  <div class="fact-indicator">
    <div class="fact-indicator__emojis">
      <span class="upset"
        ><i class="icon icon-face-upset-outline icon--xs" aria-hidden="true"
      ></i></span>
      <span class="sad"
        ><i class="icon icon-face-sad-outline icon--xs" aria-hidden="true"
      ></i></span>
      <span class="smile"
        ><i class="icon icon-face-smile-outline icon--xs" aria-hidden="true"
      ></i></span>
      <span class="happy"
        ><i class="icon icon-face-happy-outline icon--xs" aria-hidden="true"
      ></i></span>
    </div>
    <div class="fact-indicator__label">
      <h5 class="m-b--0">{{ label }}</h5>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
